import React from 'react';
import { Link } from 'react-router-dom';

export default function Alquileres() {
  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '30px 20px 60px' }}>

      <h1 style={{ color: '#1e3a6e', fontSize: '28px', margin: '0 0 6px', fontWeight: '800' }}>
        Alquileres
      </h1>
      <p style={{ color: '#64748b', fontSize: '15px', margin: '0 0 28px', lineHeight: 1.5 }}>
        Todo lo que necesitás saber sobre alquileres, desde encontrar tu propiedad hasta ajustar el precio de tu contrato.
      </p>

      {/* ── 3 CARDS DE ACCESO RÁPIDO ── */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px', marginBottom: '48px' }}>
        <Link to="/?op=Alquiler" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div style={cardStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
            <div style={{ fontSize: '36px', marginBottom: '12px' }}>🔍</div>
            <h3 style={{ margin: '0 0 8px', fontSize: '18px', color: '#1e3a6e', fontWeight: '700' }}>Quiero alquilar</h3>
            <p style={{ margin: '0 0 16px', fontSize: '14px', color: '#64748b', lineHeight: 1.5 }}>
              Explorá las propiedades en alquiler publicadas por los corredores de la CIF.
            </p>
            <span style={ctaStyle}>Ver propiedades →</span>
          </div>
        </Link>

        <Link to="/nosotros" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div style={cardStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
            <div style={{ fontSize: '36px', marginBottom: '12px' }}>📋</div>
            <h3 style={{ margin: '0 0 8px', fontSize: '18px', color: '#1e3a6e', fontWeight: '700' }}>Tengo un alquiler</h3>
            <p style={{ margin: '0 0 16px', fontSize: '14px', color: '#64748b', lineHeight: 1.5 }}>
              Acercate a un miembro de la CIF para recibir asesoramiento sobre tu contrato.
            </p>
            <span style={ctaStyle}>Contactar a la CIF →</span>
          </div>
        </Link>

        <Link to="/calculadora" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div style={cardStyle} onMouseEnter={hoverIn} onMouseLeave={hoverOut}>
            <div style={{ fontSize: '36px', marginBottom: '12px' }}>🧮</div>
            <h3 style={{ margin: '0 0 8px', fontSize: '18px', color: '#1e3a6e', fontWeight: '700' }}>Calculador de ajuste</h3>
            <p style={{ margin: '0 0 16px', fontSize: '14px', color: '#64748b', lineHeight: 1.5 }}>
              Calculá cuánto debería ser tu alquiler hoy según los índices oficiales del BCRA.
            </p>
            <span style={ctaStyle}>Calcular →</span>
          </div>
        </Link>
      </div>

      {/* ── INFO: ¿ESTOY LISTO PARA ALQUILAR? ── */}
      <h2 style={{ color: '#1e3a6e', fontSize: '22px', margin: '0 0 8px', fontWeight: '700' }}>
        ¿Estoy en condiciones de alquilar?
      </h2>
      <p style={{ color: '#64748b', fontSize: '14px', margin: '0 0 24px', lineHeight: 1.6 }}>
        Antes de buscar propiedad, es útil saber cómo te ven los propietarios e inmobiliarias. Estos son los requisitos más comunes:
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

        {/* BCRA */}
        <div style={infoCardStyle}>
          <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
            <div style={iconCircle('#e0f2fe', '#0369a1')}>🏦</div>
            <div style={{ flex: 1 }}>
              <h3 style={infoTitleStyle}>Situación crediticia en el BCRA</h3>
              <p style={infoTextStyle}>
                El Banco Central publica el historial crediticio de todas las personas. Los propietarios suelen consultar si el
                inquilino figura en <b>Situación 1</b> (normal, sin deudas vencidas).
                Situaciones 2 en adelante indican atrasos o deudas, lo que puede dificultar el alquiler.
              </p>
              <a
                href="https://www.bcra.gob.ar/BCRAyVos/Situacion_Crediticia.asp"
                target="_blank"
                rel="noreferrer"
                style={linkStyle}
              >
                Consultar mi situación en el BCRA →
              </a>
            </div>
          </div>
        </div>

        {/* Veraz / Riesgo Online */}
        <div style={infoCardStyle}>
          <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
            <div style={iconCircle('#fef9c3', '#854d0e')}>📄</div>
            <div style={{ flex: 1 }}>
              <h3 style={infoTitleStyle}>Informes crediticios privados</h3>
              <p style={infoTextStyle}>
                Además del BCRA, muchas inmobiliarias solicitan un informe de alguna de las empresas privadas de riesgo crediticio.
                Los más usados en Argentina son <b>Veraz</b> y <b>Riesgo Online</b>.
                Podés obtener tu informe gratuito una vez por mes.
              </p>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginTop: '8px' }}>
                <a href="https://www.veraz.com.ar" target="_blank" rel="noreferrer" style={linkStyle}>
                  Veraz →
                </a>
                <a href="https://www.riesgoonline.com.ar" target="_blank" rel="noreferrer" style={linkStyle}>
                  Riesgo Online →
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Garante */}
        <div style={infoCardStyle}>
          <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
            <div style={iconCircle('#f0fdf4', '#15803d')}>🤝</div>
            <div style={{ flex: 1 }}>
              <h3 style={infoTitleStyle}>Garante</h3>
              <p style={infoTextStyle}>
                Es habitual que el propietario exija un <b>garante</b>: una persona que se compromete a responder
                por el pago del alquiler si el inquilino no puede hacerlo.
                El garante también debe tener buena situación crediticia (Situación 1 en el BCRA) y,
                por lo general, se pide que sea propietario de un inmueble en la misma provincia.
              </p>
            </div>
          </div>
        </div>

      </div>

      {/* Nota CIF */}
      <div style={{ marginTop: '28px', background: '#f0f5ff', border: '1px solid #c7d7f9', borderRadius: '10px', padding: '18px 22px' }}>
        <p style={{ margin: 0, fontSize: '14px', color: '#1e3a6e', lineHeight: 1.6 }}>
          <b>¿Necesitás asesoramiento?</b> Los corredores de la CIF pueden orientarte en todo el proceso
          de búsqueda y firma del contrato.{' '}
          <Link to="/nosotros" style={{ color: '#1e3a6e', fontWeight: '700' }}>
            Contactanos →
          </Link>
        </p>
      </div>

    </div>
  );
}

const cardStyle = {
  padding: '24px',
  borderRadius: '12px',
  background: 'white',
  border: '1px solid #e2e8f0',
  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  transition: 'transform 0.15s, box-shadow 0.15s',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  boxSizing: 'border-box',
};

function hoverIn(e) {
  e.currentTarget.style.transform = 'translateY(-3px)';
  e.currentTarget.style.boxShadow = '0 8px 22px rgba(0,0,0,0.1)';
}
function hoverOut(e) {
  e.currentTarget.style.transform = 'none';
  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
}

const ctaStyle = {
  display: 'inline-block',
  color: '#1e3a6e',
  fontWeight: '700',
  fontSize: '14px',
  marginTop: 'auto',
};

const infoCardStyle = {
  background: 'white',
  border: '1px solid #e2e8f0',
  borderRadius: '12px',
  padding: '20px 22px',
  boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
};

const infoTitleStyle = {
  margin: '0 0 8px',
  fontSize: '16px',
  fontWeight: '700',
  color: '#1e3a6e',
};

const infoTextStyle = {
  margin: '0',
  fontSize: '14px',
  color: '#4b5563',
  lineHeight: 1.65,
};

const linkStyle = {
  display: 'inline-block',
  marginTop: '10px',
  color: '#1e3a6e',
  fontWeight: '700',
  fontSize: '14px',
  textDecoration: 'none',
};

function iconCircle(bg, color) {
  return {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    background: bg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    flexShrink: 0,
    color,
  };
}
